import { ComponentesModule } from './../../modules/componentes.module';

import { CommonModule } from '@angular/common';
import { Permisos } from './../../providers/authentication/permisos.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { BreadcrumbService } from '../../breadcrumb.service';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from 'ng2-translate';
import { Message } from 'primeng/primeng';

import { Predicate } from 'breeze-client';


import { IdiomaCalendario } from './../../domain/IdiomaCalendatio';
import { PermisosService } from '../../providers/authentication/permisos.service';
import { AppModule } from '../../app.module';
import { AppComponent } from '../../app.component';
import { Router } from '@angular/router';
import { mergeNsAndName } from '@angular/compiler';
import { AvisoCiudadanoFormulario } from '../../domain/AvisoCiudadanoFormulario';

import { Constantes } from '../../domain/constantes';
import { allSettled } from 'q';
// import { GeoposicionarComponent } from '../../modules/componentes.module';

// Necesario para mostrar mensajes con esta plantilla

@Component({
	templateUrl: './Mensajes.component.html',
	styleUrls: ['./Mensajes.component.scss'],
	providers: [ConfirmationService]
})

export class MensajesComponent implements OnInit, OnDestroy {
	spinner: HTMLElement;
	blockUI: HTMLElement;
	public msgs= [];
	public notificacionSeleccionada: AvisoCiudadanoFormulario = new AvisoCiudadanoFormulario();
	public secciones: any[] = [];
	public seccionesSeleccionadas: any[] = [];
	public mensajes = [];
	public mensajesFiltrados = [];

	public enviarSeccionesSeleccionadas: Boolean = false;
	public enviarVisitantesActuales: Boolean = true;

	public colsEspacio = [];
	public colsMensaje = [];
	public colSecciones = [];

	public valoresEsParaVisitantesActuales = [];

	public inputContenido = '';
	public inputTitulo = '';

	public isValid = true;
	public tituloError = false;
	public contenidoError = false;

	private idEspacio;

	public filtro = {
		where: {
			Titulo: '',
			Desde: '',
			Hasta: '',
			FechaFinDesde: '',
			FechaFinHasta:'',
			FechaInicioDesde: '',
			FechaInicioHasta:'',
			Contenido: '',
			ContAsociado: '',
			EsParaVisitantesActuales: undefined,
			Tipo: undefined,
			AccionDesencadenante: undefined,
			TiempoReenvioMinutos: undefined
		},
		order: 'FechaCreacion desc',
		top: 10,
		page: 0,
		total: 0
	};

	public AccionDesencadenante = [
		{
			tipo: 'TODOS',
			value: -1,
			clases: [],
			label: 'Contenidos.estadoTodos'
		},
		{
			tipo: 'ENTRAR',
			value: Constantes.ENVIAR_AL_ENTRAR,
			clases: [],
			label: this.translate.instant('Mensajes.alentrar')
		},
		{
			tipo: 'SALIR',
			value: Constantes.ENVIAR_AL_SALIR,
			clases: [],
			label: this.translate.instant('Mensajes.alsalir')
		},
		{
			tipo: 'ESTAN_AHORA',
			value: Constantes.ESTAN_AHORA,
			clases: [],
			label: this.translate.instant('Mensajes.estanahora')
		},
		{
			tipo: 'VISITADO_ALGUNA_VEZ',
			value: Constantes.VISITADO_ALGUNA_VEZ,
			clases: [],
			label: this.translate.instant('Mensajes.hanvisitado')
		},
		{
			tipo: 'EXPLORADO_ALGUNA_VEZ',
			value: Constantes.EXPLORADO_ALGUNA_VEZ,
			clases: [],
			label: this.translate.instant('Mensajes.hanestado')
		},
		{
			tipo: 'TIENEN_LA_APP',
			value: Constantes.TIENEN_LA_APP,
			clases: [],
			label: this.translate.instant('Mensajes.tienenapp')
		}

	];


	public AccionDesencadenanteMod = this.AccionDesencadenante[0];

	public Tipos = [
		{
			tipo: 'TODOS',
			value: -1,
			clases: [],
			label: 'Contenidos.estadoTodos'
		},
		{
			tipo: 'NOTIFICACION_INSTANTANEA',
			value: Constantes.NOTIFICACION_INSTANTANEA,
			clases: [],
			label: this.translate.instant('Mensajes.puntual')
		},
		{
			tipo: 'NOTIFICACION_PROGRAMADA',
			value: Constantes.NOTIFICACION_PROGRAMADA,
			clases: [],
			label: this.translate.instant('Mensajes.programado')
		}
	];

	// 0.- Instantanea, 1.- Programada
	static readonly NOTIFICACION_INSTANTANEA = 0;
	static readonly NOTIFICACION_PROGRAMADA = 1;

	// Tipos Programados 0.- Entrando, 1.- Saliendo
	static readonly ENVIAR_AL_ENTRAR = 0;
	static readonly ENVIAR_AL_SALIR = 1;

	// Tipos Instantaneos
	static readonly ESTAN_AHORA = 2;
	static readonly VISITADO_ALGUNA_VEZ = 3;
	static readonly EXPLORADO_ALGUNA_VEZ = 4;
	static readonly TIENEN_LA_APP = 5;



	public TiposMod = this.Tipos[0];

	idiomaCalendario: IdiomaCalendario;

	permisos: Permisos;
	msgPushNoProvisionado = [];
	espacioSeleccionado: any;

	constructor(
		private appComponent: AppComponent,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private breadcrumbService: BreadcrumbService,
		private confirmationService: ConfirmationService,
		private translate: TranslateService,
		private permisosService: PermisosService,
		private router: Router
	) {
		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Mensajes.mensajes') }
		]);

		console.log('*** MensajesComponent ***');
		this.mensajes = [];
		this.colsMensaje = [
			{ field: 'Titulo', header: this.translate.instant('Mensajes.titulo') },
			{ field: 'FechaInicio', header: this.translate.instant('Mensajes.fechainicio') },
			{ field: 'FechaFin', header: this.translate.instant('Mensajes.fechafin')},
			{ field: 'Tipo',  header: this.translate.instant('Mensajes.envio')   },
			{ field: 'AccionDesencadenante',  header: this.translate.instant('Mensajes.evento')   },
			{ field: 'destino',  header: this.translate.instant('Mensajes.destino')  },
			{ field: 'numeroEnvios', header: this.translate.instant('Mensajes.destinatarios') },
			{ field: 'MostrarEdicion', header: '' }
		];

		this.colSecciones = [
			{ field: 'Nombre', header: this.translate.instant('Mensajes.nombre') }
		];

		this.valoresEsParaVisitantesActuales = [{label: 'Verdadero', value: true}, {label: 'Falso', value: false}];

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';

		this.comprobarPermisos();
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	onPageChange(evento) {
		console.log(evento);
		this.filtro.page = evento.page;
		this.loadMensajes();
	}


	onSort(evento) {
		console.log(evento);

		if(evento.field !== 'numeroEnvios' && evento.field !== 'destino' && evento.field !== 'MostrarEdicion'){
			let field = evento.field;
			if (field === 'contenidoAsociado') {
				field = 'CONTENID.Titulo';
			}

			const sentido = evento.order > 0 ? 'ASC' : 'DESC';
			const actual = field + ' ' + sentido;
			if (actual !== this.filtro.order) {
				this.filtro.order = actual;
				this.loadMensajes();
			}
		}

	}

	onRowSelected(event){
		console.log('clicked');
	}

	getMensajesAcciones(_val) {
		for (const i in this.AccionDesencadenante) {
			if (this.AccionDesencadenante[i].value === _val) {
				return this.AccionDesencadenante[i];
			}
		}
		return {};
	}

	getMensajesTipos(_val) {
		for (const i in this.Tipos) {
			if (this.Tipos[i].value === _val) {
				return this.Tipos[i];
			}
		}
		return {};
	}

	getWhere() {
		const _titulo = this.filtro.where.Titulo;
		const _contenido = this.filtro.where.Contenido;
		let _contAsociado = this.filtro.where.ContAsociado;
		const _esParaVisitantesActuales = this.filtro.where.EsParaVisitantesActuales;
		const _desde = this.filtro.where.Desde;

		const _Tipo = this.filtro.where.Tipo;
		const _AccionDesencadenante = this.filtro.where.AccionDesencadenante;

/*			FechaFinDesde: '',
			FechaFinHasta:'',
			FechaInicioDesde: '',
			FechaInicioHasta:'',

*/
		// Fecha Inicio
		const _InicioDesde = this.filtro.where.FechaInicioDesde;
		let _fInicioDesde = new Date('1900-01-01');
		if (_InicioDesde !== ''){
			_fInicioDesde = new Date(_InicioDesde);
		}
		const where_fInicioDesde = new Predicate('FechaInicio', '>=', _fInicioDesde).or('FechaInicio', '==', null)

		const _InicioHasta = this.filtro.where.FechaInicioHasta;
		let _fInicioHasta = new Date('2100-01-01');
		if (_InicioHasta !== ''){
			_fInicioHasta = new Date(_InicioHasta);
		}
		const where_fInicioHasta = new Predicate('FechaInicio', '<=', _fInicioHasta).or('FechaInicio', '==', null)

		// Fecha Fin
		const _FinDesde = this.filtro.where.FechaFinDesde;
		let _fFinDesde = new Date('1900-01-01');
		if (_FinDesde !== ''){
			_fFinDesde = new Date(_FinDesde);
		}
		const where_fFinDesde = new Predicate('FechaFin', '>=', _fFinDesde).or('FechaFin', '==', null)

		const _FinHasta = this.filtro.where.FechaFinHasta;
		let _fFinHasta = new Date('2100-01-01');
		if (_FinHasta !== ''){
			_fFinHasta = new Date(_FinHasta);
		}
		const where_fFinHasta = new Predicate('FechaFin', '<=', _fFinHasta).or('FechaFin', '==', null)

		let _predBool = new Predicate();
		if (_esParaVisitantesActuales === undefined){

			_predBool = new Predicate('EsParaVisitantesActuales', '==', 0)
				.or('EsParaVisitantesActuales', '==', 1);
		}else{
			_predBool = new Predicate('EsParaVisitantesActuales', '==', _esParaVisitantesActuales);
		}

		let where = new Predicate('IdEspacio', '==', this.idEspacio)
			.and('Titulo', 'contains', _titulo)
			.and('Contenido', 'contains', _contenido)
			.and(_predBool)
			.and(where_fInicioDesde)
			.and(where_fInicioHasta)
			.and(where_fFinDesde)
			.and(where_fFinHasta);

		if(_Tipo === 1 || _Tipo === 0){
			where = where.and('Tipo', '==', _Tipo);
		}
		if(_AccionDesencadenante === 0 || _AccionDesencadenante === 1 || _AccionDesencadenante === 2 || _AccionDesencadenante === 3 || _AccionDesencadenante === 4 || _AccionDesencadenante === 5  ){
			where = where.and('AccionDesencadenante', '==', _AccionDesencadenante);
		}

		_contAsociado = _contAsociado.replace(' ', '')

		if (_contAsociado !== null && _contAsociado !== undefined && _contAsociado !== ''){
			if (_contAsociado.replace(/\s/g, '').length) {
				//si no esta formado solo por espacios vacios
				where = where.and('CONTENID.Titulo', 'contains', _contAsociado);
			}
		}

		return where;
	}


	filterTipos(filter) {
		this.filtro.where.Tipo = filter.value;
		this.loadMensajes();
	}

	filterAccionDesencadenante(filter) {
		this.filtro.where.AccionDesencadenante = filter.value;
		this.loadMensajes();
	}

	loadMensajes(){

		this.spinner.style.display = 'inherit';

		const that = this;

		const where = this.getWhere();
		const order = this.filtro.order;
		const top = this.filtro.top;
		const page = this.filtro.page;

		const expands = 'SECCIONES.SECCION, CONTENID, FOTO, NODOS.NODO.SECCION.ALA, ESPACIOS.ESPACIO, ENVIOS';

		return this.entityManager.getAVISOOrdenado(where, order, top, page, expands)
		.then(function (datos: any){

			if (!datos || !datos.entidades){
				that.spinner.style.display = 'none';
				return;
			}

			that.filtro.total = datos.total;

			let mensajesList = new Array();

			datos.entidades.forEach(mens => {
				try {
					const oMensaje = new AvisoCiudadanoFormulario().fromENTIDAD(mens);
					mensajesList.push(oMensaje);
				}
				catch (ex) {
					that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_MENSAJES_CARGAR'));
				}
			});

			if (mensajesList !== undefined) {
				that.mensajes = mensajesList;
				that.mensajesFiltrados = that.mensajes;

				// Ocultamos Spinner
				that.spinner.style.display = 'none';
			}
			else{
				// Ocultamos Spinner
				that.spinner.style.display = 'none';
			}

		})
		.catch(function (e) {
			console.log(e);
			that.appComponent.showError(e.message);
			return false;
		});

	}

	ngOnInit() {
		const that = this;
		window.scroll(0, 0);
		// Mostramos Spinner
		this.spinner.style.display = 'inherit';
		this.idEspacio = this.authService.getIdEspacio();

		this.loadMensajes();
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	addNuevoMensaje(){
		this.router.navigate(['/mensajes/nuevo', { es: 'nuevo' }]);
	}

	/* Validar */
	inputChanged(value) {

		const p1Error = this.inputTitulo === '' || this.inputTitulo === undefined;
		const p2Error = this.inputContenido === '' || this.inputContenido === undefined;

		// Validacion al guardar
		if (value === 'obligatorio'){
			if (p1Error) {
				this.tituloError = true;
			}
			else {
				this.tituloError = false;
			}

			if (p2Error) {
				this.contenidoError = true;
			}
			else {
				this.contenidoError = false;
			}
		}
		// validacion al editar titulo
		else if (value === 'titulo'){
			if (p1Error) {
				this.tituloError = true;
			}
			else {
				this.tituloError = false;
			}
		}
		// validacion al editar contenido
		else if (value === 'contenido'){
			if (p2Error) {
				this.contenidoError = true;
			}
			else {
				this.contenidoError = false;
			}
		}
	}

	public validar(): boolean {
		this.inputChanged('obligatorio');
		const p1 = this.tituloError;
		const p2 = this.contenidoError;

		if (p1 || p2) {
			this.isValid = false;
		}
		else {
			this.isValid = true;
		}

		return this.isValid;
	}

	mostrarEditar(aviso) {
			this.notificacionSeleccionada = aviso;
			this.notificacionSeleccionada.MostrarEdicion = true;
	}

	mostrarPrevisualizar(mensaje){
		return !(mensaje.MostrarEdicion && (mensaje.FechaFin === null || mensaje.FechaFin === undefined || mensaje.FechaFin > new Date()));
	}

	ocultarEditar(aviso) {
		aviso.MostrarEdicion = false;
	}

	editarNotificacion(event){
		console.log('editarNotificacion');
		this.router.navigate(['/mensajes/nuevo', { id: event.Id, es: 'edicion'}]);
	}

	eliminarNotificacion(aviso){
		const that = this;
		this.confirmationService.confirm({
			message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ELIMINAR'),
			header: this.translate.instant('MensajesConfirmacion.MENSAJE_CABECERA_CONFIRMACION'),
			icon: 'fa fa-question-circle',
			accept: () => {
				this.notificacionSeleccionada = aviso;

				if (aviso.numeroDestinatarios > 0) {
					aviso.ENTIDAD.FechaFin = new Date();
					that.entityManager.saveChanges()
					.then(function (resp) {
						that.appComponent.showSuccess(that.translate.instant('Mensajes.mensajeenviadook'));
						return that.loadMensajes();
					})
					.then(function (resp) {
						that.spinner.style.display = 'none';
						console.log('eliminarNotificacion');
					})
					.catch(function (e) {
						that.spinner.style.display = 'none';
						that.appComponent.showError(e.message);
						return false;
					});
				}
				else{
					this.spinner.style.display = 'inherit';
					this.entityManager.deleteAVISO(aviso.ENTIDAD)
					.then(function (resp) {
						return that.entityManager.saveChanges();
					})
					.then(function (resp) {
						that.appComponent.showSuccess(that.translate.instant('Mensajes.mensajeenviadook'));
						return that.loadMensajes();
					})
					.then(function (resp) {
						that.spinner.style.display = 'none';
						console.log('eliminarNotificacion');
					})
					.catch(function (e) {
						that.spinner.style.display = 'none';
						that.appComponent.showError(e.message);
						return false;
					});
				}
			},
			reject: () => {
				that.spinner.style.display = 'none';
			}
		});
	}

	copiarNotificacion(mensaje){
		this.spinner.style.display = 'inherit';
		const that = this;
		const idEspacio = this.authService.getIdEspacio();
		/////////
		that.router.navigate(['/mensajes/nuevo', { id: mensaje.Id, es: 'copia' }]);
		////////
/*
		this.entityManager.getEspacioById(idEspacio, 'NIVELS.ALAS.SECCIONS.NODOS')
		.then(function (espacio: any){
			that.espacioSeleccionado = espacio;
			return that.entityManager.newAVISO_CIUDADANO();
		})
		.then( function (AVISO_CIUDADANO): any {
			AVISO_CIUDADANO.Titulo = mensaje.Titulo;
			AVISO_CIUDADANO.Cuerpo = mensaje.Cuerpo;
			AVISO_CIUDADANO.FechaCreacion = new Date().getTime();
			AVISO_CIUDADANO.TiempoReenvioMinutos = mensaje.repetir ? mensaje.TiempoReenvioMinutos : null;
			AVISO_CIUDADANO.Contenido = mensaje.Contenido + ' (copia)';
			AVISO_CIUDADANO.FechaInicio  = new Date().getTime();

			AVISO_CIUDADANO.EsParaVisitantesActuales = mensaje.EsParaVisitantesActuales;
			AVISO_CIUDADANO.numeroDestinatarios = 0;

			AVISO_CIUDADANO.X  = mensaje.X;
			AVISO_CIUDADANO.Y  = mensaje.Y;
			AVISO_CIUDADANO.Latitud = mensaje.Latitud;
			AVISO_CIUDADANO.Longitud = mensaje.Longitud;

			AVISO_CIUDADANO.IdEspacio = that.espacioSeleccionado.Id;
			AVISO_CIUDADANO.ESPACIO = that.espacioSeleccionado;

			AVISO_CIUDADANO.Tipo = mensaje.Tipo;
			AVISO_CIUDADANO.AccionDesencadenante =  mensaje.AccionDesencadenante;    // 0.- Entrando, 1.- Saliendo

			AVISO_CIUDADANO.CONTENID = mensaje.CONTENID;
			AVISO_CIUDADANO.IdContenido = mensaje.IdContenido;

			mensaje.ENTIDAD = AVISO_CIUDADANO;

			return that.clonarRelaciones(mensaje, AVISO_CIUDADANO);
		})
		.then(function (datos): Q.PromiseState<any>[]  {
			return that.entityManager.saveChanges();
		})
		.then(function (resp) {
			that.spinner.style.display = 'none';
			that.router.navigate(['/mensajes/nuevo', { id: mensaje.ENTIDAD.Id, es: 'copia' }]);
			console.log('copiarNotificacion');
		})
		.catch(function (e) {
			that.spinner.style.display = 'none';
			that.appComponent.showError(e.message);
			return false;
		});
		*/
	}

	clonarRelaciones(mensajeOriginal, mensajeClonado){
		const that = this;
		const promises: any[] = [];
		const listaSeleccionados = [];
		// Creamos las Nuevas Relaciones
		if (mensajeOriginal.NODOS) {
			mensajeOriginal.NODOS.forEach(element => {
				listaSeleccionados.push(element);
				promises.push(this.entityManager.newNODO_has_AVISO());
			});
		}
		if (mensajeOriginal.ESPACIOS) {
			mensajeOriginal.ESPACIOS.forEach(element => {
				listaSeleccionados.push(element);
				promises.push(this.entityManager.newESPACIO_has_AVISO());
			});
		}
		if (mensajeOriginal.SECCIONES) {
			mensajeOriginal.SECCIONES.forEach(element => {
				listaSeleccionados.push(element);
				promises.push(this.entityManager.newSECCION_has_AVISO());
			});
		}

		if (mensajeOriginal.FOTO) {
			mensajeOriginal.FOTO.forEach(element => {
				listaSeleccionados.push(element);
				promises.push(this.entityManager.newFOTO());
			});
		}

		// resolvemos todos los promises del array
		return allSettled(promises)
		.then(function (datos) {
			for (let index = 0; index < datos.length; index++) {
				const seleccionado = listaSeleccionados[index];
				const element = datos[index].value;
				if (element.constructor.name.indexOf('ESPACIO_has_AVISO') >= 0) {
					element.IdAvisoCiudadano = mensajeClonado.Id;
					element.IdEspacio = seleccionado.IdEspacio;
				} else if (element.constructor.name.indexOf('SECCION_has_AVISO') >= 0) {
					element.IdAvisoCiudadano = mensajeClonado.Id;
					element.IdSeccion = seleccionado.IdSeccion;
				} else if (element.constructor.name.indexOf('NODO_has_AVISO') >= 0) {
					element.IdAvisoCiudadano = mensajeClonado.Id;
					element.IdNodo = seleccionado.IdNodo;
				} else if (element.constructor.name.indexOf('FOTO') >= 0) {
					element.IdAvisoCiudadano = mensajeClonado.Id;
					element.IdFotoExt = seleccionado.IdFotoExt;
					element.UrlFotoExt = seleccionado.UrlFotoExt;
				}
			}
			return datos;
		});
	}

	previewNotificacion(event){
		console.log('editarNotificacion');
		this.router.navigate(['/mensajes/nuevo', { id: event.Id, es: 'preview' }]);
	}

	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (columna === 'Desde') {
			this.filtro.where.Desde = fecha;
		}
		if (columna === 'Hasta') {
			this.filtro.where.Hasta = fecha;
		}
		if (columna === 'FechaInicioDesde') {
			this.filtro.where.FechaInicioDesde = fecha;
		}
		if (columna === 'FechaInicioHasta') {
			this.filtro.where.FechaInicioHasta = fecha;
		}
		if (columna === 'FechaFinDesde') {
			this.filtro.where.FechaFinDesde = fecha;
		}
		if (columna === 'FechaFinHasta') {
			this.filtro.where.FechaFinHasta = fecha;
		}
		this.loadMensajes();
		calendar.overlayVisible=false;
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Mensajes/Mensajes.component.ts